import { CellContext } from '@tanstack/react-table'
import { FieldArrayWithId } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { EditSchema } from 'features/inventory/ad-unit/forms/GeneralForm/schemas/editSchema'
import { getViewportWidthCellText } from 'features/inventory/ad-unit/utils'

export const ViewportWidthCell = ({
  row: { index },
  table: { getRowModel },
}: CellContext<FieldArrayWithId<EditSchema>, unknown>): string => {
  const { t } = useTranslation('features/adUnit', {
    keyPrefix: 'form.general.mediaTypes.viewportList.cells.viewportWidth',
  })

  return getViewportWidthCellText({
    errorMessage: 'Could not match Media Type range',
    index,
    rows: getRowModel().rows,
    t,
  })
}
